import { MenuItem } from "primeng/api";

export const menuItems: MenuItem[]= 
[
    {label: 'Overview', items :[
        {label: 'Portafogli', icon: 'pi pi-wallet', routerLink: ['/wallets'] },
        {label: 'Storico Patrimonio', icon: 'pi pi-wallet', routerLink: ['/wallets-progression'] },
    ]},
    {label: 'Liquidità', items :[
        {label: 'Operazioni Liq', icon: 'pi pi-money-bill', routerLink: ['/trades'] },
        {label: 'Flussi di cassa', icon: 'pi pi-book', routerLink: ['/trade-recap'] }
    ]},
    {label: 'Overview', items :[
        {label: 'Operazioni Inv', icon: 'pi pi-arrow-up-right', routerLink: ['/investments'] }
    ]}
];